module.exports = __webpack_public_path__ + "img/tax_popup2.38dd3067.png";